module.exports = __webpack_public_path__ + "img/ml1.860a9fcd.jpg";